import { Assets } from "./assets";
import { OrangeShelf1 } from "./Items/orange/orangeshelf1";

export const enum SCENES {
    BOOT = "BOOT",
    PRELOADER = "PRELOADER",
    MATTER_SHAPE_EDITOR = "MATTER_SHAPE_EDITOR",
    GAME = "GAME",
    MENU = "MENU"

}

export const GAMEVARS = {
    gameWidth: 0,
    gameHeight: 0,
    mute: false,
    pause: false,

    adTimer: 10000,
    rewardTimer: 10000,
    itemsInHand: [],
    cashInHand: 100,
    timeInGame: 0,
    cameraScale: .4,
    rewardpoints: 200,
    maincharSpeed: 1,
    selectmainchar: 1,
    itemMaxCount: 6,
    itemMaxCount1: 4,
    itemMaxCount2: 4,
    itemMaxCount3: 4,
    itemMaxCount4: 4,
    itemstaminaMaxCount1: 30,
    itemstaminaMaxCount2: 30,
    itemstaminaMaxCount3: 30,
    itemstaminaMaxCount4: 30,
    stackMaxCountUpgrade1: [[0, 8, 200], [0, 12, 500]],
    stackMaxCountUpgrade2: [[0, 7, 200], [0, 9, 600]],
    stackMaxCountUpgrade3: [[0, 6, 300], [0, 8, 700]],
    stackMaxCountUpgrade4: [[0, 7, 400], [0, 9, 800]],
    stackMaxCountUpgrade5: [[0, 8, 300], [0, 10, 700
    ]],

    staminaMaxCountUpgrade2: [[0, 100, 500], [0, 300, 1000]],
    staminaMaxCountUpgrade3: [[0, 100, 500], [0, 300, 1500]],
    staminaMaxCountUpgrade4: [[0, 200, 600], [0, 500, 1800]],
    staminaMaxCountUpgrade5: [[0, 100, 500], [0, 300, 1500]],
    cashForItems: [
        {
            name: "cashtable",
            price: 10,
            physics: true,
            key: Assets.IMG_TABLE_03.key,
            buy: false,
            itemnums: 0,


        }, {
            name: "orangeplantslot1",
            price: 15,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 1,
            itemnums: 1,
        }, {
            name: "orangeshelf1",
            price: 20,
            physics: true,
            key: Assets.IMG_STAKING_SHELF_003.key,
            buy: false,
            itemnums: 2,
        }, {
            name: "orangeplantslot2",
            price: 15,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 2,
            itemnums: 3,
        }, {
            name: "orangeplantslot3",
            price: 15,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 3,
            itemnums: 4,
        }, {
            name: "orangeplantslot4",
            price: 15,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 4,
            itemnums: 5,
        }, {
            name: "orangeplantslot5",
            price: 15,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 5,
            itemnums: 6,
        }, {
            name: "orangeplantslot6",
            price: 15,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 6,
            itemnums: 7,
        }, {
            name: "orangeplantslot7",
            price: 15,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 7,
            itemnums: 8,
        }, {
            name: "orangeplantslot8",
            price: 15,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 8,
            itemnums: 9,
        }
        , {
            name: "sugarcaneshelf1",
            price: 100,
            physics: true,
            key: Assets.IMG_STAKING_SHELF_004.key,
            buy: false,
            itemnums: 10,


        }, {
            name: "sugarcaneplantslot1",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 1,
            itemnums: 11,
        }, {
            name: "sugarcaneplantslot2",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 2,
            itemnums: 12,
        }, {
            name: "sugarcaneplantslot3",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 3,
            itemnums: 13,
        }, {
            name: "sugarcaneplantslot4",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 4,
            itemnums: 14,
        }, {
            name: "sugarcaneplantslot5",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 5,
            itemnums: 15,
        }, {
            name: "sugarcaneplantslot6",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 6,
            itemnums: 16,
        }, {
            name: "sugarcaneplantslot7",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 7,
            itemnums: 17,
        }, {
            name: "sugarcaneplantslot8",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 8,
            itemnums: 18,
        }, {
            name: "pineappleshelf1",
            price: 200,
            physics: true,
            key: Assets.IMG_STAKING_SHELF_003.key,
            buy: false,

            itemnums: 19,
        }, {
            name: "pineappleplantslot1",
            price: 30,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 1,
            itemnums: 20,
        }, {
            name: "pineappleplantslot2",
            price: 30,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 2,
            itemnums: 21,
        }, {
            name: "pineappleplantslot3",
            price: 30,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 3,
            itemnums: 22,
        }, {
            name: "pineappleplantslot4",
            price: 30,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 4,
            itemnums: 23,
        }, {
            name: "pineappleplantslot5",
            price: 30,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 5,
            itemnums: 24,
        }, {
            name: "pineappleplantslot6",
            price: 30,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 6,
            itemnums: 25,
        }, {
            name: "pineappleplantslot7",
            price: 30,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 7,
            itemnums: 26,
        }, {
            name: "pineappleplantslot8",
            price: 30,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 8,
            itemnums: 27,
        },
        {
            name: "fridge1",
            price: 300,
            physics: true,
            key: Assets.IMG_FRIDGE_01.key,
            buy: false,

            itemnums: 28,
        },
        {
            name: "orangemachine1",
            price: 500,
            physics: true,
            key: Assets.IMG_TABLE_01.key,
            buy: false,

            itemnums: 29,
        }, {
            name: "sugarcaneshelf2",
            price: 500,
            physics: true,
            key: Assets.IMG_01_STAKING_TABLE.key,
            buy: false,

            itemnums: 30,
        }, {
            name: "sugarcanemachine1",
            price: 800,
            physics: true,
            key: Assets.IMG_TABLE_01.key,
            buy: false,

            itemnums: 31,
        }, {
            name: "grapeshelf1",
            price: 600,
            physics: true,
            key: Assets.IMG_STAKING_SHELF_002.key,
            buy: false,

            itemnums: 32,
        }, {
            name: "grapeplantslot1",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 1,
            itemnums: 33,
        }, {
            name: "grapeplantslot2",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 2,
            itemnums: 34,
        }, {
            name: "grapeplantslot3",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 3,
            itemnums: 35,
        }, {
            name: "grapeplantslot4",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 4,
            itemnums: 36,
        }, {
            name: "grapeplantslot5",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 5,
            itemnums: 37,
        }, {
            name: "grapeplantslot6",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 6,
            itemnums: 38,
        }, {
            name: "grapeplantslot7",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 7,
            itemnums: 39,
        }, {
            name: "grapeplantslot8",
            price: 20,
            physics: false,
            key: Assets.IMG_PLANTING_TILE_01.key,
            buy: false,
            slotnum: 8,
            itemnums: 40,
        }, {
            name: "pineappleshelf2",
            price: 500,
            physics: true,
            key: Assets.IMG_FRIDGE.key,
            buy: false,

            itemnums: 41,
        }, {
            name: "pineapplemachine1",
            price: 800,
            physics: true,
            key: Assets.IMG_TABLE_01.key,
            buy: false,

            itemnums: 42,
        }, {
            name: "orangeshelf3",
            price: 1000,
            physics: true,
            key: Assets.IMG_01_STAKING_TABLE.key,
            buy: false,

            itemnums: 43,
        }, {
            name: "orangemachine3",
            price: 1200,
            physics: false,
            key: Assets.IMG_TABLE_02.key,
            buy: false,

            itemnums: 44,
        }, {
            name: "grapeshelf2",
            price: 600,
            physics: true,
            key: Assets.IMG_FRIDGE_02.key,
            buy: false,

            itemnums: 45,
        }, {
            name: "grapemachine1",
            price: 800,
            physics: true,
            key: Assets.IMG_TABLE_02.key,
            buy: false,

            itemnums: 46,
        }, {
            name: "pineappleshelf3",
            price: 1000,
            physics: true,
            key: Assets.IMG_01_STAKING_TABLE.key,
            buy: false,

            itemnums: 47,
        }, {
            name: "pineapplemachine3",
            price: 1200,
            physics: true,
            key: Assets.IMG_TABLE_02.key,
            buy: false,

            itemnums: 48,
        }, {
            name: "grapeshelf3",
            price: 1000,
            physics: true,
            key: Assets.IMG_01_STAKING_TABLE.key,
            buy: false,

            itemnums: 49,
        }, {
            name: "grapemachine3",
            price: 1200,
            physics: true,
            key: Assets.IMG_TABLE_02.key,
            buy: false,

            itemnums: 50,
        }, {
            name: "cashier",
            price: 600,
            physics: true,
            key: Assets.IMG_TABLE_03.key,
            buy: false,
            itemnums: 51,


        }, {
            name: "orangeHelper",
            price: 500,
            physics: true,
            key: Assets.IMG_HELPER_ORANGE_SLEEP_0001.key,
            buy: false,
            itemnums: 52,


        }, {
            name: "pineappleHelper",
            price: 500,
            physics: true,
            key: Assets.IMG_HELPER_ORANGE_SLEEP_0001.key,
            buy: false,
            itemnums: 53,


        }, {
            name: "sugarcaneHelper",
            price: 800,
            physics: true,
            key: Assets.IMG_HELPER_ORANGE_SLEEP_0001.key,
            buy: false,
            itemnums: 54,


        }, {
            name: "grapeHelper",
            price: 500,
            physics: true,
            key: Assets.IMG_HELPER_ORANGE_SLEEP_0001.key,
            buy: false,
            itemnums: 55,


        }


    ],
    upgradeItems: [{
        name: "orangeshelf1",
        upgrade: false,
        price: 100,
        num: 0

    }, {
        name: "orangemachine11",
        upgrade: false,
        price: 150,
        num: 1

    }, {
        name: "orangemachine12",
        upgrade: false,
        price: 200,
        num: 2

    }, {
        name: "orangeshelf2",
        upgrade: false,
        price: 200,
        num: 3

    }, {
        name: "orangemachine13",
        upgrade: false,
        price: 250,
        num: 4

    }, {
        name: "orangemachine14",
        upgrade: false,
        price: 250,

        num: 5

    }, {
        name: "orangeshelf3",
        upgrade: false,
        price: 300,

        num: 6

    }, {
        name: "pineappleshelf1",
        upgrade: false,
        price: 200,
        num: 7

    }, {
        name: "pineapplemachine11",
        upgrade: false,
        price: 250,
        num: 8

    }, {
        name: "pineapplemachine12",
        upgrade: false,
        price: 250,
        num: 9

    }, {
        name: "pineappleshelf2",
        upgrade: false,
        price: 300,
        num: 10

    }, {
        name: "pineapplemachine13",
        upgrade: false,
        price: 350,
        num: 11

    }, {
        name: "pineapplemachine14",
        upgrade: false,
        price: 350,

        num: 12

    }, {
        name: "pineappleshelf3",
        upgrade: false,
        price: 400,

        num: 13

    }, {
        name: "sugarcaneshelf1",
        upgrade: false,
        price: 500,
        num: 14

    }, {
        name: "sugarcanemachine11",
        upgrade: false,
        price: 550,
        num: 15

    }, {
        name: "sugarcanemachine12",
        upgrade: false,
        price: 550,
        num: 16

    }, {
        name: "sugarcaneshelf2",
        upgrade: false,
        price: 600,
        num: 17

    }, {
        name: "grapeshelf1",
        upgrade: false,
        price: 650,
        num: 18

    }, {
        name: "grapemachine11",
        upgrade: false,
        price: 650,
        num: 19

    }, {
        name: "grapemachine12",
        upgrade: false,
        price: 670,
        num: 20

    }, {
        name: "grapeshelf2",
        upgrade: false,
        price: 700,
        num: 21

    }, {
        name: "grapemachine13",
        upgrade: false,
        price: 750,
        num: 22

    }, {
        name: "grapemachine14",
        upgrade: false,
        price: 750,

        num: 23

    }, {
        name: "grapeshelf3",
        upgrade: false,
        price: 800,

        num: 24

    }
    ],
    upgradeHelpers: [{
        name: "cashier",
        upgrade: false,
        price: 300,
        num: 0

    }, {
        name: "orangeHelper",
        upgrade: false,
        price: 400,
        num: 1

    }, {
        name: "pineappleHelper",
        upgrade: false,
        price: 400,
        num: 2

    }, {
        name: "sugarcaneHelper",
        upgrade: false,
        price: 500,
        num: 3

    }, {
        name: "grapeHelper",
        upgrade: false,
        price: 400,
        num: 4

    },
    ],
    // itemsVisibility: [["orange", false], ["orangejuice", false], ["orangecandy", false]]
    itemsForCustomer: [{
        name: "orange",
        node: "N9",
        visibility: false,
        key: Assets.IMG_ORANGE

    }, {
        name: "orangejuice",
        node: "N7",
        visibility: false,
        key: Assets.IMG_JUIC

    }, {
        name: "orangecandy",
        node: "N11",
        visibility: false,
        key: Assets.IMG_CANDY

    }, {
        name: "sugarcane",
        node: "N18",
        visibility: false,
        key: Assets.IMG_SUGERCANE

    }, {
        name: "sugar",
        node: "N19",
        visibility: false,
        key: Assets.IMG_SUGER

    }, {
        name: "pineapple",
        node: "N17",
        visibility: false,
        key: Assets.IMG_PINEAPPLE

    }, {
        name: "pineapplejuice",
        node: "N16",
        visibility: false,
        key: Assets.IMG_JUICE_01

    }, {
        name: "jam",
        node: "N15",
        visibility: false,
        key: Assets.IMG_JAM

    }, {
        name: "grape",
        node: "N22",
        visibility: false,
        key: Assets.IMG_GRAPE

    }, {
        name: "grapejuice",
        node: "N24",
        visibility: false,
        key: Assets.IMG_JUICE_02

    }, {
        name: "wine",
        node: "N21",
        visibility: false,
        key: Assets.IMG_WINE

    }

    ],


};

export const FRUITSKEY = [[Assets.IMG_ORANGE, Assets.IMG_JUIC, Assets.IMG_CANDY, Assets.IMG_CANDY_MACHINE], [Assets.IMG_SUGERCANE, Assets.IMG_SUGER], [Assets.IMG_PINEAPPLE, Assets.IMG_JUICE_01, Assets.IMG_JAM, Assets.IMG_JAM_MACHINE], [Assets.IMG_GRAPE, Assets.IMG_JUICE_02, Assets.IMG_WINE, Assets.IMG_WINE_MACHINE]]

export const FRUITSNAME = [["orange", "orangejuice", "orangecandy", "orangemachine1", "orangemachine3", "orangetable14", "orangetable15", "orangetable16"], ["sugarcane", "sugar"], ["pineapple", "pineapplejuice", "jam", "pineapplemachine1", "pineapplemachine3", "pineappletable24", "pineappletable25", "pineappletable26"], ["grape", "grapejuice", "wine", "grapemachine1", "grapemachine3", "grapetable44", "grapetable45", "grapetable46"]]
export const orangHelperNodes = [["still", "N33"], ["orangeshelf1", "N34"], ["orangemachine11", "N36"], ["orangemachine12", "N37"], ["orangeshelf2", "N35"], ["orangemachine31", "N38"], ["orangemachine32", "N39"], ["orangeshelf3", "N41"], ["1", "N42"], ["2", "N43"], ["3", "N44"], ["4", "N45"], ["5", "N46"], ["6", "N47"], ["7", "N48"], ["8", "N49"], ["bin", "N53"]]
export const pineappleHelperNodes = [["still", "N61"], ["pineappleshelf1", "N17"], ["pineapplemachine11", "N55"], ["pineapplemachine12", "N56"], ["pineappleshelf2", "N16"], ["pineapplemachine31", "N57"], ["pineapplemachine32", "N58"], ["pineappleshelf3", "N15"], ["1", "N63"], ["2", "N64"], ["3", "N65"], ["4", "N66"], ["5", "N67"], ["6", "N68"], ["7", "N69"], ["8", "N70"], ["bin", "N53"]]
export const grapeHelperNodes = [["still", "N27"], ["grapeshelf1", "N22"], ["grapemachine11", "N26"], ["grapemachine12", "N72"], ["grapeshelf2", "N24"], ["grapemachine31", "N74"], ["grapemachine32", "N73"], ["grapeshelf3", "N21"], ["1", "N81"], ["2", "N82"], ["3", "N83"], ["4", "N84"], ["5", "N77"], ["6", "N78"], ["7", "N79"], ["8", "N80"], ["bin", "N53"]]
export const sugarcanHelperNodes = [["still", "N86"], ["sugarcaneshelf1", "N18"], ["sugarcanemachine11", "N87"], ["sugarcanemachine12", "N88"], ["sugarcaneshelf2", "N19"], ["1", "N91"], ["2", "N92"], ["3", "N93"], ["4", "N94"], ["5", "N95"], ["6", "N96"], ["7", "N97"], ["8", "N98"], ["orangemachine31", "N38"], ["pineapplemachine31", "N100"], ["grapemachine31", "N74"], ["bin", "N53"]]
